import { FunctionBrick, registerBrick } from 'olympe';
import { v4 as uuidv4} from 'uuid'

export default class GenerateNewUUID extends FunctionBrick {

    /**
     * Executed every time an input () gets updated.
     * Note that this method will _not_ be executed if an input value is undefined.
     * 
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function(string)} setUUID
     */
    onUpdate(context, inputs, [setUUID]) {
        setUUID(uuidv4())
    }
}

registerBrick('017ba1d0d8cad39f643c', GenerateNewUUID);
